import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ kicker, title, description, align = "left", testId }) => (
  <Reveal
    data-testid={testId}
    className={`mb-12 max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
  >
    <p className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-secondary">
      {kicker}
    </p>
    <h2 className="text-balance text-3xl leading-tight tracking-tight text-primary md:text-5xl">
      {title}
    </h2>
    {description ? (
      <p className="mt-5 text-base leading-relaxed text-muted-foreground md:text-lg">
        {description}
      </p>
    ) : null}
  </Reveal>
);
